import { useQuery } from "@tanstack/react-query";

import { fetchSurveyState } from "../api/client";

export function useSurveyState(token: string | undefined) {
  return useQuery({
    queryKey: ["survey", "pmf", token],
    // Non-null assertion is safe: `enabled: !!token` guarantees the queryFn
    // never runs without a token.
    queryFn: () => fetchSurveyState(token!),
    enabled: !!token,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
